/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Compare_TitleInputs */

const en_home_compare_title = /** @type {(inputs: Home_Compare_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CADCraft vs AutoCAD at a glance`)
};

/**
* | output |
* | --- |
* | "CADCraft vs AutoCAD at a glance" |
*
* @param {Home_Compare_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const home_compare_title = /** @type {((inputs?: Home_Compare_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Compare_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_home_compare_title(inputs)
});
export { home_compare_title as "home.compare.title" }